import { render, staticRenderFns } from "./payment.html?vue&type=template&id=022c693f&scoped=true&external"
import script from "./payment.js?vue&type=script&lang=js&external"
export * from "./payment.js?vue&type=script&lang=js&external"
import style0 from "./payment.scss?vue&type=style&index=0&id=022c693f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c693f",
  null
  
)

export default component.exports